import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TopChartFilters from "@client.components/TopChartFilters";
import {
  TopTimeConsumingMeetings,
  TotalMeetingsCost,
} from "@client.components/Charts";
import { makeFilter } from "@client.components/TopChartFilters/reducer";
import LeftSideBar from "../LeftSideBar";
import { setReportsError } from "../reducer";
import "../Reports.scss";

const ReportsCompany = () => {
  const [setTopBarTitle] = useOutletContext();
  const { t } = useTranslation();
  const filter = useSelector(makeFilter);
  const dispatch = useDispatch();

  const setPageError = useCallback(
    (err) => {
      dispatch(setReportsError(err));
    },
    [dispatch]
  );

  useEffect(() => {
    setTopBarTitle(t("components.NavigationBar.reports"));
  }, [t, setTopBarTitle]);

  return (
    <div className="reports">
      <LeftSideBar />
      <div className="reports-content">
        <TopChartFilters />
        <div className="charts">
          <div className="chart-grid">
            <TotalMeetingsCost
              isOwn={false}
              filter={filter}
              onError={setPageError}
            />
            <TopTimeConsumingMeetings filter={filter} onError={setPageError} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportsCompany;
